import { ESearchParams } from 'common/const/searchParams.enum';
import { IFormValue } from 'common/models';

export const searchParamsToFormValues = (searchParams: URLSearchParams) => {
  const formValues: IFormValue = {};
  const defaultActiveKeys: number[] = [];

  searchParams.forEach((value, key) => {
    switch (key) {
      case ESearchParams.CatalogId:
      case ESearchParams.CategoryId: {
        formValues[key] = Number(value);
        break;
      }
      case ESearchParams.Search:
      case ESearchParams.IsAvailableForPurchase: {
        formValues[key] = value;
        break;
      }
      default: {
        // Example key = 1[from], properyId = 1
        const propertyId = Number(key.split('[')[0]);
        // Example key = 1[from], propertySubindex = from
        const propertySubindex = key.match(/\[(.*?)\]/)?.[1];

        defaultActiveKeys.push(propertyId);

        if (!propertySubindex) {
          // Value is a string
          formValues[propertyId] = value;
        } else {
          const propertySubindexNumber = parseInt(propertySubindex);

          if (!isNaN(propertySubindexNumber)) {
            // Value is an array element
            const propertyFormValue = formValues[propertyId] || [];
            formValues[propertyId] = [...propertyFormValue, value];
          } else {
            // Value is the value of the object's property
            const propertyFormValue = formValues[propertyId] || [];
            formValues[propertyId] = [{ ...propertyFormValue[0], [propertySubindex]: Number(value) }];
          }
        }
        break;
      }
    }
  });

  return { formValues, defaultActiveKeys };
};

export const isMatchedBySearch = (text: string, query: string): boolean => {
  return text.toLowerCase().includes(query.toLocaleLowerCase());
};

const safeParse = (v: string): any => {
  try {
    return JSON.parse(v);
  } catch {
    return v;
  }
};

export const parseFilters = (searchParams: URLSearchParams, param?: string): Record<string, any> => {
  const keys = param ? [param] : Array.from(new Set(searchParams.keys()));
  const filters: Record<string, any> = {};

  keys.forEach((key) => {
    if (!key.startsWith('f_')) {
      return;
    }

    const rawValues = searchParams.getAll(key);

    if (!rawValues.length) {
      return;
    }

    const cleanKey = key.slice(2);

    const parsed = rawValues.map(safeParse);

    const isRange =
      parsed.length === 1 &&
      parsed[0] &&
      typeof parsed[0] === 'object' &&
      // type = range
      parsed[0].t === 'r';

    filters[cleanKey] = isRange ? parsed[0] : parsed;
  });

  return filters;
};
